'use client';
import { sendGTM, GaActionType } from '@fe-cnyes/fe-common-gtm';
/* eslint-disable import/no-extraneous-dependencies */
import { styled } from '@linaria/react';

type Props = {
  width?: number;
  height?: number;
  url: string;
  target?: '_self' | '_blank';
  children?: React.ReactNode | string;
  active?: boolean;
  gtmEvent?: GaActionType;
};

const Container = styled.a<{
  width?: number;
  height?: number;
  active?: boolean;
}>`
  background-color: ${({ active }) => (active ? 'white' : '#e03f19')};
  color: ${({ active }) => (active ? '#e03f19' : 'white')};
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: ${({ height }) => (height ? `${height}px` : '100%')};
  line-height: ${({ height }) => (height ? `${height}px` : 'unset')};
  display: block;
  text-align: center;
  border-radius: 4px;
  outline: ${({ active }) => (active ? '1px solid #e03f19' : 'unset')};
`;

const Buy = ({ width, height, url, target, children, active, gtmEvent }: Props) => {
  const handleClick = () => {
    if (gtmEvent) sendGTM(gtmEvent);
  };

  return (
    <Container href={url} target={target} width={width} height={height} active={active} onClick={handleClick}>
      {children}
    </Container>
  );
};

export default Buy;
